module.exports = __webpack_public_path__ + "img/33985bec1601446e810e0da9510dba81-1440.7653248a.jpg";